import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CancelledOrderDetailsLayer from "../components/CancelledOrderDetailsLayer";

const CancelledOrderDetailsPage = () => {
    return (
        <MasterLayout>
            <CancelledOrderDetailsLayer />
        </MasterLayout>
    );
};

export default CancelledOrderDetailsPage;
